<template>
  <b-tab title="Instrumentos" class="m-0 p-0">
    <div class="tab-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE INSTRUMENTOS :::::::::::::::::::::::::::: -->
      <b-table bordered hover small head-variant="light" :items="getFilterInstrumentos(filtro)" :fields="fields.instrumento">
        <template #cell(calibracao)="data">
          <div>
            <p class="pt-0 pb-0">
              {{ moment(data.item.calibracao).format("DD/MM/YYYY") }}
            </p>
          </div>
        </template>

        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="editar(data.item)" v-b-tooltip.hover title="Editar">
              <b-icon icon="pencil-square" variant="primary"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <!-- :::::::::::::::::::::::::::: BARRA DE AÇÕES :::::::::::::::::::::::::::: -->
    <div class="menu-acoes pb-2">
      <div id="search-bar">
        <b-col cols="10" class="p-1 pr-0">
          <b-form inline>
            <b-button size="sm" class="pl-2 pr-3" variant="info" @click="adicionar()">
              <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2" />Adicionar
            </b-button>
            <b-form-input
              id="instrumento-filter"
              type="search"
              size="sm"
              class="m-1 p-1"
              placeholder="Filtre pela descrição do instrumento."
              v-model="filtro"
            />
            <b-icon icon="search" variant="light" scale="1.2" class="m-1" />
          </b-form>
        </b-col>
      </div>
      <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
      <instrumento-modal ref="editor" />
    </div>
  </b-tab>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useInstrumentoStore } from "@/stores/InstrumentoStore";
import Instrumento from "@/models/Instrumento";
import TableFields from "@/tools/TableFields";
import InstrumentoModal from "@/components/modals/inspecao/InstrumentoModal";

export default {
  name: "InstrumentoTabList",

  data() {
    return {
      fields: new TableFields(),
      filtro: "",
      consumivel: new Instrumento(),
    };
  },

  components: {
    "instrumento-modal": InstrumentoModal,
  },

  methods: {
    adicionar() {
      this.instrumento = new Instrumento();
      this.$refs.editor.call(this.instrumento);
    },

    editar(instrumento) {
      this.$refs.editor.call(instrumento);
    },
  },

  setup() {
    const store = useSgcqStore();
    const instrumentoStore = useInstrumentoStore();
    const { getFilterInstrumentos } = storeToRefs(instrumentoStore);

    return {
      store,
      instrumentoStore,
      getFilterInstrumentos,
    };
  },
};
</script>

<style lang="scss" scoped>
#instrumento-filter {
  width: 30rem;
}
.menu-acoes {
  background-color: #112a4a;
}
</style>
